import React from 'react';
import App from './src/App';
export default () => (
    <App />
)



